<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header data-background-color="primary">
                        <h4 class="title">Log in</h4>
                    </md-card-header>
                    <md-card-content>
                        <img class="logo" :src="require('@/assets/img/newance-logo.svg')"/>
                        <form>
                            <md-field :class="getValidationClass('email')">
                                <label>Email</label>
                                <md-input v-model="credentials.email"/>
                                <span v-if="this.$store.getters.hasValidationError('email')" class="md-error">{{ this.$store.getters.getValidationError('email') }}</span>
                            </md-field>
                            <md-field :class="getValidationClass('password')">
                                <label>Password</label>
                                <md-input v-model="credentials.password" type="password"/>
                                <span v-if="this.$store.getters.hasValidationError('password')" class="md-error">{{ this.$store.getters.getValidationError('password') }}</span>
                            </md-field>
                            <md-card-actions>
                                <md-button type="submit" @click.prevent="submit" class="md-raised md-primary">Login</md-button>
                            </md-card-actions>
                        </form>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "login",
    data() {
        return {
        credentials: {
            email: null,
            password: null
        }
        };
    },
    methods: {
        submit() {
            this.$store.dispatch("login", this.credentials);
        },
        getValidationClass (fieldName) {
            if (this.$store.getters.hasValidationError(fieldName)) {
                console.log(this.$store.getters.getValidationError(fieldName))
                return 'md-invalid'
            }
        },
    }
};
</script>

<style scoped>
.logo {
    padding: 0 50px;
    margin-bottom: 20px;
}

.md-card {
    background-color: #ff4136;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);

    max-width: 400px;
    width: 90%;
}

input {
    margin-top: 10px;
    padding-left: 15px;
    width: 90%;
    height: 30px;
    border-radius: 9999px;
    border-style: none;
}
</style>